module.exports = __webpack_public_path__ + "media/images/app/homepage/categories/necklaces-9341677605fc990175c553946d35dae1.webp";